import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {ProviderSummaryModel} from './providerSummary.model';
import {ProviderServiceSummaryModel} from '../../../service/api/entity/providerServiceSummary.model';

export class ProviderModel extends WithSummaryModel<ProviderSummaryModel>{
    services: ProviderServiceSummaryModel [] = [];
}
